import { NoteArray } from './note';

export interface INotesAll  {
    MemberNotes: NoteArray;
    LicenseNotes: NoteArray;
    CreditCardNotes: NoteArray;
    CreditNotes: NoteArray;
    GISNotes: NoteArray;
    AdminLogNotes: NoteArray;
    MemberLogNotes: NoteArray;

}

export class NotesAll  implements INotesAll {
    MemberNotes: NoteArray;
    LicenseNotes: NoteArray;
    CreditCardNotes: NoteArray;
    CreditNotes: NoteArray;
    GISNotes: NoteArray;
    GISUsageNotes: NoteArray;
    AdminLogNotes: NoteArray;
    MemberLogNotes: NoteArray;

    public static  FixDates(notes: NotesAll) {

        NoteArray.FixDates(notes.MemberNotes);
        NoteArray.FixDates(notes.LicenseNotes);
        NoteArray.FixDates(notes.CreditCardNotes);
        NoteArray.FixDates(notes.CreditNotes);
        NoteArray.FixDates(notes.GISNotes);
        NoteArray.FixDates(notes.GISUsageNotes);
        NoteArray.FixDates(notes.AdminLogNotes);
        NoteArray.FixDates(notes.MemberLogNotes);


    }

}
